<template>
  <span>
    <v-dialog v-model="dialog" width="600">
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <v-icon :size="iconSize">{{activatorIcon ? activatorIcon:'mdi-file-search-outline'}}</v-icon>
        </v-btn>
      </template>

      <v-card width="100%" class="mx-auto">
        <v-toolbar>
          <v-toolbar-title>Lookup Available Course Topics</v-toolbar-title>
          <v-btn class="ml-auto" icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-toolbar collapse dense v-if="hideSearch">
          <v-spacer />Search
          <v-btn icon @click="hideSearch = !hideSearch">
            <v-icon>mdi-export</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text v-else class="mt-5">
          <v-text-field
            :loading="isAppLoading"
            outlined
            :hide-details="true"
            label="Filter topics by keywords"
            append-icon="mdi-text-search"
            v-model="term"
            @keydown.enter="searchTopics"
            @click:append="searchTopics"
          ></v-text-field>
          <v-row>
            <v-col cols="6">
              <v-select
                v-model="selectedGrade"
                :items="grades"
                item-text="name"
                item-value="value"
                label="Grade"
                :clearable="true"
              />
            </v-col>
            <v-col cols="6">
              <v-select
                :clearable="true"
                v-model="selectedSubject"
                :items="subjects"
                label="Subject"
              />
            </v-col>
          </v-row>
          <v-btn @click="searchTopics">Search</v-btn>
        </v-card-text>

        <v-card class="mt-5" v-if="selectedResults.length > 0">
          <v-card-title>
            Selected {{selectedResults.length}} Topics
            <v-spacer />
            <v-btn @click="chooseTopics">Done with Selection</v-btn>
          </v-card-title>
        </v-card>
        <hr class="my-3" />
        <v-card-title>Found {{totalElements}} topics</v-card-title>
        <v-treeview :open-all="openTree" v-model="selectedResults" selectable :items="searchResults" />
        <v-pagination class="mt-5" :length="pageLength" :total-visible="8" v-model="page" />
        <br />
        <br />
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  props: ["activatorIcon", "searchTerms", "grade", "subject", "iconSize", "filterCourses"],
  data() {
    return {
      dialog: false,
      hideSearch: false,
      page: 1,
      pageLength: 0,
      pageSize: 5,
      totalElements: 0,
      totalCourseCount: 0,
      searchResults: [],
      selectedResults: [],
      allTopics: [],
      openTree: true,
      term: "",
      selectedGrade: null,
      selectedSubject: null
    };
  },
  watch: {
    dialog(show) {
      if (show) {
        this.openDialog();
      }
    },
    page(newPage) {
      console.log(`go to page ${newPage}`);
      this.searchTopics();
    }
  },
  computed: {
    ...mapGetters(["isAppLoading", "grades", "subjects"]),
    filterCourseIds(){
      if(this.filterCourses){
        return this.filterCourses.map( c => c.id );
      }
      else{
        return [];
      }
    }
  },
  methods: {
    ...mapActions(["addErrorMessage"]),
    searchTopics() {
      const data = {
        pageIndex: this.page,
        searchTerms: this.term,
        grade: this.selectedGrade,
        subject: this.selectedSubject,
        pageSize: 20
      };
      this.$axios
        .post("/course/topics/search", data)
        .then(resp => {
          // console.log(resp.data);
          const responseData = resp.data.data.content || [];

          //group topic by course
          let groups = [];
          let topics = [];
          responseData.forEach(arr => {
            // const topics = arr[0];
            const course = arr[1].course;
            if(this.filterCourseIds.includes(course.id)){
              return
            }

            const courseId = `c_${course.id}`;
            const topic = arr[1].topic;
            topics.push(topic);
            const index = groups.findIndex(r => r.courseId == course.id);
            const materialsCount = topic['topic_topicMaterials'].length;

            if (index < 0) {
              groups.push({
                id: courseId,
                courseId: course.id,
                name: course.name,
                children: [{ id: topic.id, name: `${topic.name} (${materialsCount} materials)` }]
              });
            } else {
              groups[index].children.push({ id: topic.id, name: `${topic.name} (${materialsCount} materials)`});
            }
          });

          this.searchResults = groups;
          if (this.searchResults && this.searchResults.length > 0) {
            this.hideSearch = true;
          }

          this.allTopics = topics;

          this.pageLength = resp.data.data.totalPages;
          this.totalElements = resp.data.data.totalElements;
          this.totalCourseCount = groups.length;
        })
        .catch(resp => {
          // console.log(resp)
          this.addErrorMessage(resp.data.message || resp.data);
        });
    },
    openDialog(event) {
      this.$emit("onOpen", event);
    },
    chooseTopics() {
      const selectedTopics = this.allTopics.filter(t =>
        this.selectedResults.includes(t.id)
      );
      this.$emit("selectedTopics", selectedTopics);

      this.dialog = false;
    }
  },
  mounted() {
    this.term = this.searchTerms;
    this.selectedGrade = this.grade;
    this.selectedSubject = this.subject;
  }
};
</script>

<style>
</style>